module.exports = __webpack_public_path__ + "static/media/pk.3238f8e2.svg";